/**
 * GPS设备新增和编辑
 */
import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Select, message } from 'antd';
import { gpsDeviceAddRequest, gpsDeviceEditRequest } from '@/service/gpsDevice';

interface OperateModalProps {
  data?: any;
  type?: string;
  closeModal: () => void;
  reloadData: () => void;
}

const OperateModal = (props: OperateModalProps) => {
  const [operateLoading, setOperateLoading] = useState(false);
  const [form] = Form.useForm();
  const { data, type, closeModal, reloadData } = props;

  // 编辑时回填数据
  useEffect(() => {
    if (type === 'edit' && data) {
      form.setFieldsValue({
        deviceId: data.deviceId,
        manufacturer: data.manufacturer,
        plateNumber: data.plateNumber,
      });
    } else {
      form.resetFields();
    }
  }, [type, data]);

  // 提交
  const submit = async () => {
    try {
      setOperateLoading(true);
      const values = await form.validateFields();
      const isEdit = type === 'edit';
      const params: any = { ...values };
      if (isEdit && data?.id) {
        params.id = data.id;
      }
      const requestFunc = isEdit ? gpsDeviceEditRequest : gpsDeviceAddRequest;
      const res = await requestFunc(params);
      if (res.data?.code === 0) {
        message.success(isEdit ? '编辑成功' : '新增成功');
        setOperateLoading(false);
        closeModal();
        reloadData();
      } else {
        setOperateLoading(false);
      }
    } catch (error) {
      setOperateLoading(false);
    }
  };

  return (
    <Modal
      title={type === 'add' ? '新增GPS监测设备' : '编辑GPS监测设备'}
      open
      onCancel={closeModal}
      onOk={submit}
      bodyStyle={{ maxHeight: '70vh', overflow: 'auto' }}
      centered
      okButtonProps={{ loading: operateLoading }}
      maskClosable={false}
      okText="提交"
      cancelText="取消"
    >
      <Form
        form={form}
        autoComplete="off"
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
      >
        <Form.Item
          label="设备SN"
          name="deviceId"
          rules={[{ required: true, message: '请输入设备SN' }]}
        >
          <Input placeholder="请输入设备SN" />
        </Form.Item>
        <Form.Item
          label="厂家"
          name="manufacturer"
          rules={[{ required: true, message: '请选择厂家' }]}
        >
          <Select placeholder="请选择厂家">
            <Select.Option value="途强">途强</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="绑定车辆"
          name="plateNumber"
          rules={[{ required: true, message: '请输入绑定车辆' }]}
        >
          <Input placeholder="请输入绑定车辆" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default OperateModal;
